import { Qualification } from "@src/appV2/Admin/Qualifications/types";
import { Dispatch, SetStateAction } from "react";

export enum LICENSE_STATUSES {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  REJECTED = "REJECTED",
  ARCHIVED = "ARCHIVED",
  EXPIRING = "EXPIRING",
}

export interface ICreateLicense {
  qualification: string;
  state: string;
  multiState: boolean;
  status: LICENSE_STATUSES;
  number: string;
  issueDate?: string;
  expiresAt: string;
  notifyRejection?: boolean;
  rejectionReason?: string;
  rejectionNoteForWorker?: string;
  fileStorageFileKey?: string;
  fileStorageRootFolder?: string;
  fileName?: string;
}

export type IUpdateLicense = Partial<ICreateLicense>;

export interface ILicenseDetails extends ICreateLicense {
  id: string;
  createdAt: string;
  duplicate?: boolean;
}

export interface ILicenseFormProps {
  agentId?: string;
  qualifications: Qualification[];
  license: ICreateLicense;
  setLicense?: Dispatch<SetStateAction<ICreateLicense>>;
  licenseDetailsMode: boolean;
  userHasLicenseManagerRole: boolean;
  showFilePreview: boolean;
  disableRejectionForm?: boolean;
}

export interface IAddLicenseProps {
  licenseData?: ILicenseDetails;
  isVisible: boolean;
  agentId: string;
  loadAgentLicenses: () => void;
  handleCancel: () => void;
  agent: { tmz: string; email: string; isTestAccount: boolean };
}

export interface ILicenseStatusButtonGroupProps {
  selectedStatus: LICENSE_STATUSES;
  onSelected: (status: LICENSE_STATUSES) => void;
  disabled: boolean;
}

export interface IRejectionReasonFormProps {
  license: ICreateLicense;
  handleLicenseUpdate: (key: string, value: string | boolean) => void;
  disableForm: boolean;
}

export interface ILicenseDocPreviewProps {
  fileStorageFileKey: string;
  workerId: string;
  isPreviewImage: boolean;
  width?: string;
  height?: string;
  setLicense?: Dispatch<SetStateAction<ICreateLicense>>;
  license: ICreateLicense;
}

export interface ILicenseChangeLogsProps {
  workerId: string;
}

export interface IWorkerLicenseChangeLog {
  createdAt: string;
  action: string;
  updateType: string;
  document: { _id: string; name: string };
  updatedFields: string;
  performedBy: { type: string; userId: string; email: string | null };
  performedFor: { userId: string };
}

export interface IWorkerLicensesCount {
  PENDING?: number;
  ARCHIVED?: number;
  EXPIRED?: number;
  EXPIRING?: number;
  REJECTED?: number;
  ACTIVE?: number;
}
